import type {
  CoachHistory,
  CoachNow,
  CoachSummary,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-1074 point 5 — the coach's "Aktuellt" read model.
// `@Roles("coach", "doctor", ...ADMIN_ROLES)` on the route, matching the
// roles that open the coach's patient page.
export async function fetchCoachNow(patientId: string): Promise<CoachNow> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}/coach-now`,
    { headers: tenantHeader(), ...withCredentials },
  );
  return jsonOr401<CoachNow>(res);
}

// TES-1101 — the coach's top summary, under the header. Same roles as above.
export async function fetchCoachSummary(
  patientId: string,
): Promise<CoachSummary> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}/coach-summary`,
    { headers: tenantHeader(), ...withCredentials },
  );
  return jsonOr401<CoachSummary>(res);
}

// TES-1207 — the coach's Historik, under Patientbild. Same roles as above.
export async function fetchCoachHistory(
  patientId: string,
): Promise<CoachHistory> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}/coach-history`,
    { headers: tenantHeader(), ...withCredentials },
  );
  return jsonOr401<CoachHistory>(res);
}
